import { cx } from 'utils/cx'

import styles from './SizeGuideCell.module.scss'

interface SizeGuideCellProps {
	readonly value: string
	readonly description?: string
	readonly className?: string
}

export function SizeGuideCell({
	value,
	description,
	className,
}: SizeGuideCellProps): React.ReactNode {
	return (
		<div className={cx(styles.sizeGuideCell, className)}>
			{value}
			{description && <span className={styles.description}>{description}</span>}
		</div>
	)
}
